import ComingSoon from "../Components/ComingSoon";

export default function UseDash() {
    return (
        <>
           <ComingSoon />
        </>

    );
}